const n = (e) => "light" in e;
export {
  n as isStennTheme
};
//# sourceMappingURL=isStennTheme.mjs.map
